// extracted by mini-css-extract-plugin
module.exports = {"container":"card_container__1NHtN","card":"card_card__24S1t","infected":"card_infected__28D8i","recovered":"card_recovered__1eyP7","deaths":"card_deaths__I2SDN"};